/**
 * Do not edit directly, this file was auto-generated.
 */

export const primitivesColorNeutral25 = "#fafafc";
export const primitivesColorNeutral50 = "#fafafa";
export const primitivesColorNeutral75 = "#f5f5f7";
export const primitivesColorNeutral100 = "#f5f5f5";
export const primitivesColorNeutral150 = "#eeeeef";
export const primitivesColorNeutral200 = "#eeeeee";
export const primitivesColorNeutral300 = "#e0e0e0";
export const primitivesColorNeutral400 = "#bdbdbd";
export const primitivesColorNeutral500 = "#9e9e9e";
export const primitivesColorNeutral600 = "#757575";
export const primitivesColorNeutral700 = "#616161";
export const primitivesColorNeutral800 = "#424242";
export const primitivesColorNeutral900 = "#212121";
export const primitivesColorNeutral950 = "#141515";
export const primitivesColorNeutralWhite = "#ffffff";
export const primitivesColorNeutralBlack = "#000000";
export const primitivesColorRed50 = "#fcf2f5";
export const primitivesColorRed75 = "#f8e5ea";
export const primitivesColorRed100 = "#f2ccd5";
export const primitivesColorRed200 = "#e599ac";
export const primitivesColorRed300 = "#d86682";
export const primitivesColorRed400 = "#cb3358";
export const primitivesColorRed500 = "#bd002f";
export const primitivesColorRed600 = "#980025";
export const primitivesColorRed700 = "#72001c";
export const primitivesColorRed800 = "#4c0013";
export const primitivesColorRed900 = "#260009";
export const primitivesColorOrange50 = "#fff8f2";
export const primitivesColorOrange75 = "#fef1e5";
export const primitivesColorOrange100 = "#fee4cc";
export const primitivesColorOrange200 = "#fdc999";
export const primitivesColorOrange300 = "#fbad66";
export const primitivesColorOrange400 = "#fa9233";
export const primitivesColorOrange500 = "#f97700";
export const primitivesColorOrange600 = "#c75f00";
export const primitivesColorOrange700 = "#954700";
export const primitivesColorOrange800 = "#643000";
export const primitivesColorOrange900 = "#321800";
export const primitivesColorYellow50 = "#fefbe8";
export const primitivesColorYellow75 = "#fcf3c1";
export const primitivesColorYellow100 = "#f9eb9a";
export const primitivesColorYellow200 = "#f6e273";
export const primitivesColorYellow300 = "#f3d84d";
export const primitivesColorYellow400 = "#f3ce12";
export const primitivesColorYellow500 = "#dbba13";
export const primitivesColorYellow600 = "#b39811";
export const primitivesColorYellow700 = "#8c770f";
export const primitivesColorYellow800 = "#65560c";
export const primitivesColorYellow900 = "#3f3608";
export const primitivesColorGreen50 = "#f2fbf7";
export const primitivesColorGreen75 = "#e5f6ef";
export const primitivesColorGreen100 = "#cceedf";
export const primitivesColorGreen200 = "#99dcbf";
export const primitivesColorGreen300 = "#66cb9f";
export const primitivesColorGreen400 = "#33b97f";
export const primitivesColorGreen500 = "#00a85f";
export const primitivesColorGreen600 = "#00864c";
export const primitivesColorGreen700 = "#006539";
export const primitivesColorGreen800 = "#004326";
export const primitivesColorGreen900 = "#002213";
export const primitivesColorBlue50 = "#f2f7fd";
export const primitivesColorBlue75 = "#e5f0fc";
export const primitivesColorBlue100 = "#cce0f8";
export const primitivesColorBlue200 = "#99c2f2";
export const primitivesColorBlue300 = "#66a3eb";
export const primitivesColorBlue400 = "#3385e5";
export const primitivesColorBlue500 = "#0066de";
export const primitivesColorBlue600 = "#0052b2";
export const primitivesColorBlue700 = "#003d85";
export const primitivesColorBlue800 = "#002959";
export const primitivesColorBlue900 = "#00142c";
export const primitivesColorPurple50 = "#f7f5fe";
export const primitivesColorPurple75 = "#efecfc";
export const primitivesColorPurple100 = "#dfd8f4";
export const primitivesColorPurple200 = "#c0b1f4";
export const primitivesColorPurple300 = "#a08bef";
export const primitivesColorPurple400 = "#8164e9";
export const primitivesColorPurple500 = "#613de4";
export const primitivesColorPurple600 = "#4e31b6";
export const primitivesColorPurple700 = "#3a2589";
export const primitivesColorPurple800 = "#27185b";
export const primitivesColorPurple900 = "#130c2e";
export const primitivesColorChartChart1 = "#8965e4";
export const primitivesColorChartChart2 = "#ffa556";
export const primitivesColorChartChart3 = "#62a0cb";
export const primitivesColorChartChart4 = "#6bbc6b";
export const primitivesColorChartChart5 = "#e26868";
export const primitivesColorChartChart6 = "#ae8981";
export const primitivesColorChartChart7 = "#eba0d4";
export const primitivesColorChartChart8 = "#a5a5a5";
export const primitivesColorChartChart9 = "#d0d164";
export const primitivesColorChartChart10 = "#5dd2dd";
export const primitivesColorBrandManifold = "#685bc7";
export const primitivesColorBrandDeepSpace = "#201547";
export const primitivesColorBrandGalaxy = "#f5f7f8";
export const primitivesColorBrandMoonglow = "#c5b4e3";
export const primitivesColorBrandForgeFire = "#ff6a39";
export const primitivesColorBrandHotBlue = "#2d68c4";
export const primitivesColorBrandGraphite = "#5a5b5d";
export const primitivesColorExtendedNova = "#8f1ba0";
export const semanticsLightButtonFilledPrimaryDefaultSurface = "#613de4";
export const semanticsLightButtonFilledPrimaryDefaultText = "#ffffff";
export const semanticsLightButtonFilledPrimaryDefaultIcon = "#ffffff";
export const semanticsLightButtonFilledPrimaryHoverText = "#ffffff";
export const semanticsLightButtonFilledPrimaryHoverIcon = "#ffffff";
export const semanticsLightButtonFilledPrimaryHoverSurface = "#27185b";
export const semanticsLightButtonFilledPrimaryFocusText = "#ffffff";
export const semanticsLightButtonFilledPrimaryFocusIcon = "#ffffff";
export const semanticsLightButtonFilledPrimaryFocusSurface = "#27185b";
export const semanticsLightButtonFilledPrimaryLoadingText = "#ffffff";
export const semanticsLightButtonFilledPrimaryLoadingIcon = "#ffffff";
export const semanticsLightButtonFilledPrimaryLoadingSurface = "#613de4";
export const semanticsLightButtonFilledPrimaryDisabledText = "#9e9e9e";
export const semanticsLightButtonFilledPrimaryDisabledIcon = "#9e9e9e";
export const semanticsLightButtonFilledPrimaryDisabledSurface = "#e0e0e0";
export const semanticsLightButtonFilledPrimaryPressedText = "#ffffff";
export const semanticsLightButtonFilledPrimaryPressedIcon = "#ffffff";
export const semanticsLightButtonFilledPrimaryPressedSurface = "#130c2e";
export const semanticsLightButtonFilledSecondaryDefaultText = "#141515";
export const semanticsLightButtonFilledSecondaryDefaultIcon = "#141515";
export const semanticsLightButtonFilledSecondaryDefaultSurface = "#e0e0e0";
export const semanticsLightButtonFilledSecondaryHoverText = "#141515";
export const semanticsLightButtonFilledSecondaryHoverIcon = "#141515";
export const semanticsLightButtonFilledSecondaryHoverSurface = "#bdbdbd";
export const semanticsLightButtonFilledSecondaryFocusText = "#141515";
export const semanticsLightButtonFilledSecondaryFocusIcon = "#141515";
export const semanticsLightButtonFilledSecondaryFocusSurface = "#bdbdbd";
export const semanticsLightButtonFilledSecondaryLoadingText = "#141515";
export const semanticsLightButtonFilledSecondaryLoadingIcon = "#141515";
export const semanticsLightButtonFilledSecondaryLoadingSurface = "#e0e0e0";
export const semanticsLightButtonFilledSecondaryDisabledText = "#9e9e9e";
export const semanticsLightButtonFilledSecondaryDisabledIcon = "#9e9e9e";
export const semanticsLightButtonFilledSecondaryDisabledSurface = "#e0e0e0";
export const semanticsLightButtonFilledSecondaryPressedText = "#141515";
export const semanticsLightButtonFilledSecondaryPressedIcon = "#141515";
export const semanticsLightButtonFilledSecondaryPressedSurface = "#9e9e9e";
export const semanticsLightButtonFilledDestructiveDefaultText = "#ffffff";
export const semanticsLightButtonFilledDestructiveDefaultIcon = "#ffffff";
export const semanticsLightButtonFilledDestructiveDefaultSurface = "#bd002f";
export const semanticsLightButtonFilledDestructiveHoverText = "#ffffff";
export const semanticsLightButtonFilledDestructiveHoverIcon = "#ffffff";
export const semanticsLightButtonFilledDestructiveHoverSurface = "#980025";
export const semanticsLightButtonFilledDestructiveFocusText = "#ffffff";
export const semanticsLightButtonFilledDestructiveFocusIcon = "#ffffff";
export const semanticsLightButtonFilledDestructiveFocusSurface = "#980025";
export const semanticsLightButtonFilledDestructiveLoadingText = "#ffffff";
export const semanticsLightButtonFilledDestructiveLoadingIcon = "#ffffff";
export const semanticsLightButtonFilledDestructiveLoadingSurface = "#bd002f";
export const semanticsLightButtonFilledDestructiveDisabledText = "#9e9e9e";
export const semanticsLightButtonFilledDestructiveDisabledIcon = "#9e9e9e";
export const semanticsLightButtonFilledDestructiveDisabledSurface = "#e0e0e0";
export const semanticsLightButtonFilledDestructivePressedText = "#ffffff";
export const semanticsLightButtonFilledDestructivePressedIcon = "#ffffff";
export const semanticsLightButtonFilledDestructivePressedSurface = "#4c0013";
export const semanticsLightButtonFilledSuccessDefaultText = "#ffffff";
export const semanticsLightButtonFilledSuccessDefaultIcon = "#ffffff";
export const semanticsLightButtonFilledSuccessDefaultSurface = "#00a85f";
export const semanticsLightButtonFilledSuccessHoverText = "#ffffff";
export const semanticsLightButtonFilledSuccessHoverIcon = "#ffffff";
export const semanticsLightButtonFilledSuccessHoverSurface = "#006539";
export const semanticsLightButtonFilledSuccessFocusText = "#ffffff";
export const semanticsLightButtonFilledSuccessFocusIcon = "#ffffff";
export const semanticsLightButtonFilledSuccessFocusSurface = "#006539";
export const semanticsLightButtonFilledSuccessLoadingText = "#ffffff";
export const semanticsLightButtonFilledSuccessLoadingIcon = "#ffffff";
export const semanticsLightButtonFilledSuccessLoadingSurface = "#00a85f";
export const semanticsLightButtonFilledSuccessDisabledText = "#9e9e9e";
export const semanticsLightButtonFilledSuccessDisabledIcon = "#9e9e9e";
export const semanticsLightButtonFilledSuccessDisabledSurface = "#e0e0e0";
export const semanticsLightButtonFilledSuccessPressedText = "#ffffff";
export const semanticsLightButtonFilledSuccessPressedIcon = "#ffffff";
export const semanticsLightButtonFilledSuccessPressedSurface = "#004326";
export const semanticsLightButtonOutlineSecondaryDefaultText = "#141515";
export const semanticsLightButtonOutlineSecondaryDefaultIcon = "#141515";
export const semanticsLightButtonOutlineSecondaryDefaultBorder = "#bdbdbd";
export const semanticsLightButtonOutlineSecondaryHoverText = "#141515";
export const semanticsLightButtonOutlineSecondaryHoverIcon = "#141515";
export const semanticsLightButtonOutlineSecondaryHoverBorder = "#bdbdbd";
export const semanticsLightButtonOutlineSecondaryHoverSurface = "#f5f5f5";
export const semanticsLightButtonOutlineSecondaryFocusText = "#141515";
export const semanticsLightButtonOutlineSecondaryFocusIcon = "#141515";
export const semanticsLightButtonOutlineSecondaryFocusBorder = "#bdbdbd";
export const semanticsLightButtonOutlineSecondaryFocusSurface = "#f5f5f5";
export const semanticsLightButtonOutlineSecondaryLoadingText = "#141515";
export const semanticsLightButtonOutlineSecondaryLoadingIcon = "#141515";
export const semanticsLightButtonOutlineSecondaryLoadingBorder = "#bdbdbd";
export const semanticsLightButtonOutlineSecondaryDisabledText = "#9e9e9e";
export const semanticsLightButtonOutlineSecondaryDisabledIcon = "#9e9e9e";
export const semanticsLightButtonOutlineSecondaryDisabledBorder = "#bdbdbd";
export const semanticsLightButtonOutlineSecondaryDisabledSurface = "#e0e0e0";
export const semanticsLightButtonOutlineSecondaryPressedText = "#141515";
export const semanticsLightButtonOutlineSecondaryPressedIcon = "#141515";
export const semanticsLightButtonOutlineSecondaryPressedBorder = "#bdbdbd";
export const semanticsLightButtonOutlineSecondaryPressedSurface = "#9e9e9e";
export const semanticsLightButtonOutlinePrimaryDefaultText = "#613de4";
export const semanticsLightButtonOutlinePrimaryDefaultIcon = "#613de4";
export const semanticsLightButtonOutlinePrimaryDefaultBorder = "#613de4";
export const semanticsLightButtonOutlinePrimaryHoverText = "#613de4";
export const semanticsLightButtonOutlinePrimaryHoverIcon = "#613de4";
export const semanticsLightButtonOutlinePrimaryHoverBorder = "#613de4";
export const semanticsLightButtonOutlinePrimaryHoverSurface = "#efecfc";
export const semanticsLightButtonOutlinePrimaryFocusText = "#613de4";
export const semanticsLightButtonOutlinePrimaryFocusIcon = "#613de4";
export const semanticsLightButtonOutlinePrimaryFocusBorder = "#613de4";
export const semanticsLightButtonOutlinePrimaryFocusSurface = "#efecfc";
export const semanticsLightButtonOutlinePrimaryLoadingText = "#613de4";
export const semanticsLightButtonOutlinePrimaryLoadingIcon = "#613de4";
export const semanticsLightButtonOutlinePrimaryLoadingBorder = "#613de4";
export const semanticsLightButtonOutlinePrimaryDisabledText = "#9e9e9e";
export const semanticsLightButtonOutlinePrimaryDisabledIcon = "#9e9e9e";
export const semanticsLightButtonOutlinePrimaryDisabledBorder = "#bdbdbd";
export const semanticsLightButtonOutlinePrimaryDisabledSurface = "#e0e0e0";
export const semanticsLightButtonOutlinePrimaryPressedText = "#613de4";
export const semanticsLightButtonOutlinePrimaryPressedIcon = "#613de4";
export const semanticsLightButtonOutlinePrimaryPressedBorder = "#613de4";
export const semanticsLightButtonOutlinePrimaryPressedSurface = "#c0b1f4";
export const semanticsLightButtonOutlineDestructiveDefaultText = "#980025";
export const semanticsLightButtonOutlineDestructiveDefaultIcon = "#980025";
export const semanticsLightButtonOutlineDestructiveDefaultBorder = "#bd002f";
export const semanticsLightButtonOutlineDestructiveHoverText = "#980025";
export const semanticsLightButtonOutlineDestructiveHoverIcon = "#980025";
export const semanticsLightButtonOutlineDestructiveHoverBorder = "#bd002f";
export const semanticsLightButtonOutlineDestructiveHoverSurface = "#f8e5ea";
export const semanticsLightButtonOutlineDestructiveFocusText = "#980025";
export const semanticsLightButtonOutlineDestructiveFocusIcon = "#980025";
export const semanticsLightButtonOutlineDestructiveFocusBorder = "#bd002f";
export const semanticsLightButtonOutlineDestructiveFocusSurface = "#f8e5ea";
export const semanticsLightButtonOutlineDestructiveLoadingText = "#980025";
export const semanticsLightButtonOutlineDestructiveLoadingIcon = "#980025";
export const semanticsLightButtonOutlineDestructiveLoadingBorder = "#bd002f";
export const semanticsLightButtonOutlineDestructiveDisabledText = "#9e9e9e";
export const semanticsLightButtonOutlineDestructiveDisabledIcon = "#9e9e9e";
export const semanticsLightButtonOutlineDestructiveDisabledBorder = "#bdbdbd";
export const semanticsLightButtonOutlineDestructiveDisabledSurface = "#e0e0e0";
export const semanticsLightButtonOutlineDestructivePressedText = "#980025";
export const semanticsLightButtonOutlineDestructivePressedIcon = "#980025";
export const semanticsLightButtonOutlineDestructivePressedBorder = "#bd002f";
export const semanticsLightButtonOutlineDestructivePressedSurface = "#e599ac";
export const semanticsLightButtonOutlineSuccessDefaultText = "#00864c";
export const semanticsLightButtonOutlineSuccessDefaultIcon = "#00864c";
export const semanticsLightButtonOutlineSuccessDefaultBorder = "#00a85f";
export const semanticsLightButtonOutlineSuccessHoverText = "#00864c";
export const semanticsLightButtonOutlineSuccessHoverIcon = "#00864c";
export const semanticsLightButtonOutlineSuccessHoverBorder = "#00a85f";
export const semanticsLightButtonOutlineSuccessHoverSurface = "#e5f6ef";
export const semanticsLightButtonOutlineSuccessFocusText = "#00864c";
export const semanticsLightButtonOutlineSuccessFocusIcon = "#00864c";
export const semanticsLightButtonOutlineSuccessFocusBorder = "#00a85f";
export const semanticsLightButtonOutlineSuccessFocusSurface = "#e5f6ef";
export const semanticsLightButtonOutlineSuccessLoadingText = "#00864c";
export const semanticsLightButtonOutlineSuccessLoadingIcon = "#00864c";
export const semanticsLightButtonOutlineSuccessLoadingBorder = "#00a85f";
export const semanticsLightButtonOutlineSuccessDisabledText = "#9e9e9e";
export const semanticsLightButtonOutlineSuccessDisabledIcon = "#9e9e9e";
export const semanticsLightButtonOutlineSuccessDisabledBorder = "#bdbdbd";
export const semanticsLightButtonOutlineSuccessDisabledSurface = "#e0e0e0";
export const semanticsLightButtonOutlineSuccessPressedText = "#00864c";
export const semanticsLightButtonOutlineSuccessPressedIcon = "#00864c";
export const semanticsLightButtonOutlineSuccessPressedBorder = "#00a85f";
export const semanticsLightButtonOutlineSuccessPressedSurface = "#99dcbf";
export const semanticsLightButtonGhostPrimaryDefaultText = "#613de4";
export const semanticsLightButtonGhostPrimaryDefaultIcon = "#613de4";
export const semanticsLightButtonGhostPrimaryHoverText = "#613de4";
export const semanticsLightButtonGhostPrimaryHoverIcon = "#613de4";
export const semanticsLightButtonGhostPrimaryHoverSurface = "#efecfc";
export const semanticsLightButtonGhostPrimaryFocusText = "#613de4";
export const semanticsLightButtonGhostPrimaryFocusIcon = "#613de4";
export const semanticsLightButtonGhostPrimaryFocusSurface = "#efecfc";
export const semanticsLightButtonGhostPrimaryLoadingText = "#613de4";
export const semanticsLightButtonGhostPrimaryLoadingIcon = "#613de4";
export const semanticsLightButtonGhostPrimaryDisabledText = "#9e9e9e";
export const semanticsLightButtonGhostPrimaryDisabledIcon = "#9e9e9e";
export const semanticsLightButtonGhostPrimaryPressedText = "#613de4";
export const semanticsLightButtonGhostPrimaryPressedIcon = "#613de4";
export const semanticsLightButtonGhostPrimaryPressedSurface = "#c0b1f4";
export const semanticsLightButtonGhostSecondaryDefaultText = "#141515";
export const semanticsLightButtonGhostSecondaryDefaultIcon = "#141515";
export const semanticsLightButtonGhostSecondaryHoverText = "#141515";
export const semanticsLightButtonGhostSecondaryHoverIcon = "#141515";
export const semanticsLightButtonGhostSecondaryHoverSurface = "#f5f5f5";
export const semanticsLightButtonGhostSecondaryFocusText = "#141515";
export const semanticsLightButtonGhostSecondaryFocusIcon = "#141515";
export const semanticsLightButtonGhostSecondaryFocusSurface = "#f5f5f5";
export const semanticsLightButtonGhostSecondaryLoadingText = "#141515";
export const semanticsLightButtonGhostSecondaryLoadingIcon = "#141515";
export const semanticsLightButtonGhostSecondaryDisabledText = "#9e9e9e";
export const semanticsLightButtonGhostSecondaryDisabledIcon = "#9e9e9e";
export const semanticsLightButtonGhostSecondaryPressedText = "#141515";
export const semanticsLightButtonGhostSecondaryPressedIcon = "#141515";
export const semanticsLightButtonGhostSecondaryPressedSurface = "#bdbdbd";
export const semanticsLightButtonGhostDestructiveDefaultText = "#980025";
export const semanticsLightButtonGhostDestructiveDefaultIcon = "#980025";
export const semanticsLightButtonGhostDestructiveHoverText = "#980025";
export const semanticsLightButtonGhostDestructiveHoverIcon = "#980025";
export const semanticsLightButtonGhostDestructiveHoverSurface = "#f8e5ea";
export const semanticsLightButtonGhostDestructiveFocusText = "#980025";
export const semanticsLightButtonGhostDestructiveFocusIcon = "#980025";
export const semanticsLightButtonGhostDestructiveFocusSurface = "#f8e5ea";
export const semanticsLightButtonGhostDestructiveLoadingText = "#980025";
export const semanticsLightButtonGhostDestructiveLoadingIcon = "#980025";
export const semanticsLightButtonGhostDestructiveDisabledText = "#9e9e9e";
export const semanticsLightButtonGhostDestructiveDisabledIcon = "#9e9e9e";
export const semanticsLightButtonGhostDestructivePressedText = "#980025";
export const semanticsLightButtonGhostDestructivePressedIcon = "#980025";
export const semanticsLightButtonGhostDestructivePressedSurface = "#e599ac";
export const semanticsLightButtonGhostSuccessDefaultText = "#00864c";
export const semanticsLightButtonGhostSuccessDefaultIcon = "#00864c";
export const semanticsLightButtonGhostSuccessHoverText = "#00864c";
export const semanticsLightButtonGhostSuccessHoverIcon = "#00864c";
export const semanticsLightButtonGhostSuccessHoverSurface = "#e5f6ef";
export const semanticsLightButtonGhostSuccessFocusText = "#00864c";
export const semanticsLightButtonGhostSuccessFocusIcon = "#00864c";
export const semanticsLightButtonGhostSuccessFocusSurface = "#e5f6ef";
export const semanticsLightButtonGhostSuccessLoadingText = "#00864c";
export const semanticsLightButtonGhostSuccessLoadingIcon = "#00864c";
export const semanticsLightButtonGhostSuccessDisabledText = "#9e9e9e";
export const semanticsLightButtonGhostSuccessDisabledIcon = "#9e9e9e";
export const semanticsLightButtonGhostSuccessPressedText = "#00864c";
export const semanticsLightButtonGhostSuccessPressedIcon = "#00864c";
export const semanticsLightButtonGhostSuccessPressedSurface = "#99dcbf";
export const semanticsLightText = "#ffffff";
export const semanticsLightIcon = "#ffffff";
export const semanticsLightSurface = "#27185b";
export const semanticsLightInputDefaultDefaultBorder = "#bdbdbd";
export const semanticsLightInputDefaultDefaultLeftIcon = "#141515";
export const semanticsLightInputDefaultDefaultRightIcon = "#9e9e9e";
export const semanticsLightInputDefaultDefaultLabel = "#141515";
export const semanticsLightInputDefaultDefaultPlaceholder = "#757575";
export const semanticsLightInputDefaultDefaultDescription = "#757575";
export const semanticsLightInputDefaultDefaultLink = "#9e9e9e";
export const semanticsLightInputDefaultDefaultSurface = "#ffffff";
export const semanticsLightInputDefaultFocusLabel = "#141515";
export const semanticsLightInputDefaultFocusLink = "#9e9e9e";
export const semanticsLightInputDefaultFocusPlaceholder = "#757575";
export const semanticsLightInputDefaultFocusDescription = "#757575";
export const semanticsLightInputDefaultFocusLeftIcon = "#141515";
export const semanticsLightInputDefaultFocusRightIcon = "#9e9e9e";
export const semanticsLightInputDefaultFocusBorder = "#bdbdbd";
export const semanticsLightInputDefaultFocusSurface = "#ffffff";
export const semanticsLightInputDefaultFilledLabel = "#141515";
export const semanticsLightInputDefaultFilledLink = "#9e9e9e";
export const semanticsLightInputDefaultFilledPlaceholder = "#141515";
export const semanticsLightInputDefaultFilledDescription = "#757575";
export const semanticsLightInputDefaultFilledLeftIcon = "#141515";
export const semanticsLightInputDefaultFilledRightIcon = "#9e9e9e";
export const semanticsLightInputDefaultFilledBorder = "#bdbdbd";
export const semanticsLightInputDefaultFilledSurface = "#ffffff";
export const semanticsLightInputDefaultDisabledLabel = "#141515";
export const semanticsLightInputDefaultDisabledLink = "#9e9e9e";
export const semanticsLightInputDefaultDisabledPlaceholder = "#757575";
export const semanticsLightInputDefaultDisabledDescription = "#757575";
export const semanticsLightInputDefaultDisabledLeftIcon = "#757575";
export const semanticsLightInputDefaultDisabledRightIcon = "#9e9e9e";
export const semanticsLightInputDefaultDisabledBorder = "#bdbdbd";
export const semanticsLightInputDefaultDisabledSurface = "#e0e0e0";
export const semanticsLightInputDefaultErrorLabel = "#141515";
export const semanticsLightInputDefaultErrorLink = "#9e9e9e";
export const semanticsLightInputDefaultErrorPlaceholder = "#141515";
export const semanticsLightInputDefaultErrorDescription = "#980025";
export const semanticsLightInputDefaultErrorLeftIcon = "#141515";
export const semanticsLightInputDefaultErrorRightIcon = "#9e9e9e";
export const semanticsLightInputDefaultErrorBorder = "#bd002f";
export const semanticsLightInputDefaultErrorSurface = "#ffffff";
export const semanticsLightInputDefaultErrorFocusLabel = "#141515";
export const semanticsLightInputDefaultErrorFocusLink = "#9e9e9e";
export const semanticsLightInputDefaultErrorFocusPlaceholder = "#141515";
export const semanticsLightInputDefaultErrorFocusDescription = "#980025";
export const semanticsLightInputDefaultErrorFocusLeftIcon = "#141515";
export const semanticsLightInputDefaultErrorFocusRightIcon = "#9e9e9e";
export const semanticsLightInputDefaultErrorFocusBorder = "#bd002f";
export const semanticsLightInputDefaultErrorFocusSurface = "#ffffff";
export const semanticsLightInputFileDefaultLabel = "#141515";
export const semanticsLightInputFileDefaultLabelText = "#141515";
export const semanticsLightInputFileDefaultDescription = "#757575";
export const semanticsLightInputFileDefaultBorder = "#bdbdbd";
export const semanticsLightInputFileDefaultSurface = "#ffffff";
export const semanticsLightInputFileDefaultButtonText = "#757575";
export const semanticsLightInputFileFocusLabel = "#141515";
export const semanticsLightInputFileFocusLabelText = "#141515";
export const semanticsLightInputFileFocusButtonText = "#757575";
export const semanticsLightInputFileFocusDescription = "#757575";
export const semanticsLightInputFileFocusBorder = "#bdbdbd";
export const semanticsLightInputFileFocusSurface = "#ffffff";
export const semanticsLightInputFileFilledLabel = "#141515";
export const semanticsLightInputFileFilledLabelText = "#141515";
export const semanticsLightInputFileFilledButtonText = "#141515";
export const semanticsLightInputFileFilledDescription = "#757575";
export const semanticsLightInputFileFilledBorder = "#bdbdbd";
export const semanticsLightInputFileFilledSurface = "#ffffff";
export const semanticsLightInputFileDisabledLabel = "#141515";
export const semanticsLightInputFileDisabledLabelText = "#757575";
export const semanticsLightInputFileDisabledButtonText = "#757575";
export const semanticsLightInputFileDisabledDescription = "#757575";
export const semanticsLightInputFileDisabledBorder = "#bdbdbd";
export const semanticsLightInputFileDisabledSurface = "#e0e0e0";
export const semanticsLightInputFileErrorLabel = "#141515";
export const semanticsLightInputFileErrorLabelText = "#141515";
export const semanticsLightInputFileErrorButtonText = "#141515";
export const semanticsLightInputFileErrorDescription = "#980025";
export const semanticsLightInputFileErrorBorder = "#bd002f";
export const semanticsLightInputFileErrorSurface = "#ffffff";
export const semanticsLightInputFileErrorFocusLabel = "#141515";
export const semanticsLightInputFileErrorFocusLabelText = "#141515";
export const semanticsLightInputFileErrorFocusButtonText = "#141515";
export const semanticsLightInputFileErrorFocusDescription = "#980025";
export const semanticsLightInputFileErrorFocusBorder = "#bd002f";
export const semanticsLightInputFileErrorFocusSurface = "#ffffff";
export const semanticsLightSelectDefaultLabel = "#141515";
export const semanticsLightSelectDefaultPlaceholder = "#757575";
export const semanticsLightSelectDefaultDescription = "#757575";
export const semanticsLightSelectDefaultLeftIcon = "#141515";
export const semanticsLightSelectDefaultRightIcon = "#9e9e9e";
export const semanticsLightSelectDefaultBorder = "#bdbdbd";
export const semanticsLightSelectDefaultSurface = "#ffffff";
export const semanticsLightSelectFocusLabel = "#141515";
export const semanticsLightSelectFocusPlaceholder = "#757575";
export const semanticsLightSelectFocusDescription = "#757575";
export const semanticsLightSelectFocusLeftIcon = "#141515";
export const semanticsLightSelectFocusRightIcon = "#9e9e9e";
export const semanticsLightSelectFocusBorder = "#bdbdbd";
export const semanticsLightSelectFocusSurface = "#f5f5f5";
export const semanticsLightSelectFilledLabel = "#141515";
export const semanticsLightSelectFilledPlaceholder = "#141515";
export const semanticsLightSelectFilledDescription = "#757575";
export const semanticsLightSelectFilledLeftIcon = "#141515";
export const semanticsLightSelectFilledRightIcon = "#9e9e9e";
export const semanticsLightSelectFilledBorder = "#bdbdbd";
export const semanticsLightSelectFilledSurface = "#ffffff";
export const semanticsLightSelectFilledFocusLabel = "#141515";
export const semanticsLightSelectFilledFocusPlaceholder = "#141515";
export const semanticsLightSelectFilledFocusDescription = "#757575";
export const semanticsLightSelectFilledFocusLeftIcon = "#141515";
export const semanticsLightSelectFilledFocusRightIcon = "#9e9e9e";
export const semanticsLightSelectFilledFocusBorder = "#bdbdbd";
export const semanticsLightSelectFilledFocusSurface = "#ffffff";
export const semanticsLightSelectDisabledLabel = "#141515";
export const semanticsLightSelectDisabledPlaceholder = "#757575";
export const semanticsLightSelectDisabledDescription = "#757575";
export const semanticsLightSelectDisabledLeftIcon = "#141515";
export const semanticsLightSelectDisabledRightIcon = "#9e9e9e";
export const semanticsLightSelectDisabledBorder = "#bdbdbd";
export const semanticsLightSelectDisabledSurface = "#e0e0e0";
export const semanticsLightSelectMenuLabelDefaultText = "#9e9e9e";
export const semanticsLightSelectMenuItemDefaultText = "#141515";
export const semanticsLightSelectMenuItemDefaultIcon = "#141515";
export const semanticsLightSelectMenuItemDefaultBorder = "#bdbdbd";
export const semanticsLightSelectMenuItemDefaultAccent = "#f5f5f5";
export const semanticsLightSelectMenuContainerDefaultSurface = "#ffffff";
export const semanticsLightSelectMenuContainerDefaultBorder = "#e0e0e0";
export const semanticsLightAvatarFallbackDefaultText = "#4e31b6";
export const semanticsLightAvatarFallbackDefaultSurface = "#efecfc";
export const semanticsLightAvatarGroupDefaultBorder = "#ffffff";
export const semanticsLightUserChipSelectedDefaultText = "#141515";
export const semanticsLightUserChipSelectedDefaultBorder = "#613de4";
export const semanticsLightUserChipSelectedDefaultSurface = "#f7f5fe";
export const semanticsLightUserChipSelectedHoverText = "#141515";
export const semanticsLightUserChipSelectedHoverBorder = "#613de4";
export const semanticsLightUserChipSelectedHoverSurface = "#efecfc";
export const semanticsLightUserChipUnselectedDefaultText = "#141515";
export const semanticsLightUserChipUnselectedDefaultBorder = "#e0e0e0";
export const semanticsLightUserChipUnselectedDefaultSurface = "#ffffff";
export const semanticsLightUserChipUnselectedHoverText = "#141515";
export const semanticsLightUserChipUnselectedHoverBorder = "#e0e0e0";
export const semanticsLightUserChipUnselectedHoverSurface = "#fafafa";
export const semanticsLightUserChipDisabledDefaultText = "#757575";
export const semanticsLightUserChipDisabledDefaultSurface = "#e0e0e0";
export const semanticsLightImageChipSelectedDefaultBorder = "#613de4";
export const semanticsLightImageChipSelectedDefaultSurface = "#f7f5fe";
export const semanticsLightImageChipSelectedHoverBorder = "#613de4";
export const semanticsLightImageChipSelectedHoverSurface = "#efecfc";
export const semanticsLightImageChipUnselectedDefaultBorder = "#e0e0e0";
export const semanticsLightImageChipUnselectedDefaultSurface = "#ffffff";
export const semanticsLightImageChipUnselectedHoverBorder = "#e0e0e0";
export const semanticsLightImageChipUnselectedHoverSurface = "#fafafa";
export const semanticsLightImageChipDisabledDefaultSurface = "#e0e0e0";
export const semanticsLightCheckboxActiveDefaultLabel = "#141515";
export const semanticsLightCheckboxActiveDefaultDescription = "#757575";
export const semanticsLightCheckboxActiveDefaultBorder = "#613de4";
export const semanticsLightCheckboxActiveDefaultSurface = "#613de4";
export const semanticsLightCheckboxActiveDefaultIcon = "#ffffff";
export const semanticsLightCheckboxActiveFocusLabel = "#141515";
export const semanticsLightCheckboxActiveFocusDescription = "#757575";
export const semanticsLightCheckboxActiveFocusIcon = "#ffffff";
export const semanticsLightCheckboxActiveFocusBorder = "#613de4";
export const semanticsLightCheckboxActiveFocusSurface = "#613de4";
export const semanticsLightCheckboxActiveDisabledLabel = "#757575";
export const semanticsLightCheckboxActiveDisabledDescription = "#757575";
export const semanticsLightCheckboxActiveDisabledIcon = "#ffffff";
export const semanticsLightCheckboxActiveDisabledBorder = "#757575";
export const semanticsLightCheckboxActiveDisabledSurface = "#757575";
export const semanticsLightCheckboxActivePressedLabel = "#130c2e";
export const semanticsLightCheckboxActivePressedDescription = "#757575";
export const semanticsLightCheckboxActivePressedIcon = "#ffffff";
export const semanticsLightCheckboxActivePressedBorder = "#130c2e";
export const semanticsLightCheckboxActivePressedSurface = "#130c2e";
export const semanticsLightCheckboxInactiveDefaultLabel = "#141515";
export const semanticsLightCheckboxInactiveDefaultDescription = "#757575";
export const semanticsLightCheckboxInactiveDefaultBorder = "#e0e0e0";
export const semanticsLightCheckboxInactiveDefaultSurface = "#ffffff";
export const semanticsLightCheckboxInactiveFocusLabel = "#141515";
export const semanticsLightCheckboxInactiveFocusDescription = "#757575";
export const semanticsLightCheckboxInactiveFocusBorder = "#e0e0e0";
export const semanticsLightCheckboxInactiveFocusSurface = "#ffffff";
export const semanticsLightCheckboxInactiveDisabledLabel = "#757575";
export const semanticsLightCheckboxInactiveDisabledDescription = "#757575";
export const semanticsLightCheckboxInactiveDisabledBorder = "#e0e0e0";
export const semanticsLightCheckboxInactiveDisabledSurface = "#ffffff";
export const semanticsLightCheckboxInactivePressedLabel = "#130c2e";
export const semanticsLightCheckboxInactivePressedDescription = "#757575";
export const semanticsLightCheckboxInactivePressedBorder = "#e0e0e0";
export const semanticsLightCheckboxInactivePressedSurface = "#ffffff";
export const semanticsLightRadioInactiveDefaultLabel = "#141515";
export const semanticsLightRadioInactiveDefaultDescription = "#757575";
export const semanticsLightRadioInactiveDefaultBorder = "#e0e0e0";
export const semanticsLightRadioInactiveDefaultSurface = "#ffffff";
export const semanticsLightRadioInactiveFocusLabel = "#141515";
export const semanticsLightRadioInactiveFocusDescription = "#757575";
export const semanticsLightRadioInactiveFocusBorder = "#9e9e9e";
export const semanticsLightRadioInactiveFocusSurface = "#ffffff";
export const semanticsLightRadioActiveDefaultLabel = "#141515";
export const semanticsLightRadioActiveDefaultDescription = "#757575";
export const semanticsLightRadioActiveDefaultBorder = "#e0e0e0";
export const semanticsLightRadioActiveDefaultSurface = "#ffffff";
export const semanticsLightRadioActiveDefaultIcon = "#613de4";
export const semanticsLightRadioActiveFocusLabel = "#141515";
export const semanticsLightRadioActiveFocusDescription = "#757575";
export const semanticsLightRadioActiveFocusIcon = "#613de4";
export const semanticsLightRadioActiveFocusBorder = "#9e9e9e";
export const semanticsLightRadioActiveFocusSurface = "#ffffff";
export const semanticsDarkButtonFilledPrimaryDefaultSurface = "#613de4";
export const semanticsDarkButtonFilledPrimaryDefaultText = "#ffffff";
export const semanticsDarkButtonFilledPrimaryDefaultIcon = "#ffffff";
export const semanticsDarkButtonFilledPrimaryHoverText = "#ffffff";
export const semanticsDarkButtonFilledPrimaryHoverIcon = "#ffffff";
export const semanticsDarkButtonFilledPrimaryHoverSurface = "#27185b";
export const semanticsDarkButtonFilledPrimaryFocusText = "#ffffff";
export const semanticsDarkButtonFilledPrimaryFocusIcon = "#ffffff";
export const semanticsDarkButtonFilledPrimaryFocusSurface = "#27185b";
export const semanticsDarkButtonFilledPrimaryLoadingText = "#ffffff";
export const semanticsDarkButtonFilledPrimaryLoadingIcon = "#ffffff";
export const semanticsDarkButtonFilledPrimaryLoadingSurface = "#613de4";
export const semanticsDarkButtonFilledPrimaryDisabledText = "#757575";
export const semanticsDarkButtonFilledPrimaryDisabledIcon = "#757575";
export const semanticsDarkButtonFilledPrimaryDisabledSurface = "#424242";
export const semanticsDarkButtonFilledPrimaryPressedText = "#ffffff";
export const semanticsDarkButtonFilledPrimaryPressedIcon = "#ffffff";
export const semanticsDarkButtonFilledPrimaryPressedSurface = "#130c2e";
export const semanticsDarkButtonFilledSecondaryDefaultText = "#141515";
export const semanticsDarkButtonFilledSecondaryDefaultIcon = "#141515";
export const semanticsDarkButtonFilledSecondaryDefaultSurface = "#e0e0e0";
export const semanticsDarkButtonFilledSecondaryHoverText = "#141515";
export const semanticsDarkButtonFilledSecondaryHoverIcon = "#141515";
export const semanticsDarkButtonFilledSecondaryHoverSurface = "#bdbdbd";
export const semanticsDarkButtonFilledSecondaryFocusText = "#141515";
export const semanticsDarkButtonFilledSecondaryFocusIcon = "#141515";
export const semanticsDarkButtonFilledSecondaryFocusSurface = "#bdbdbd";
export const semanticsDarkButtonFilledSecondaryLoadingText = "#141515";
export const semanticsDarkButtonFilledSecondaryLoadingIcon = "#141515";
export const semanticsDarkButtonFilledSecondaryLoadingSurface = "#e0e0e0";
export const semanticsDarkButtonFilledSecondaryDisabledText = "#757575";
export const semanticsDarkButtonFilledSecondaryDisabledIcon = "#757575";
export const semanticsDarkButtonFilledSecondaryDisabledSurface = "#424242";
export const semanticsDarkButtonFilledSecondaryPressedText = "#141515";
export const semanticsDarkButtonFilledSecondaryPressedIcon = "#141515";
export const semanticsDarkButtonFilledSecondaryPressedSurface = "#9e9e9e";
export const semanticsDarkButtonFilledDestructiveDefaultText = "#ffffff";
export const semanticsDarkButtonFilledDestructiveDefaultIcon = "#ffffff";
export const semanticsDarkButtonFilledDestructiveDefaultSurface = "#bd002f";
export const semanticsDarkButtonFilledDestructiveHoverText = "#ffffff";
export const semanticsDarkButtonFilledDestructiveHoverIcon = "#ffffff";
export const semanticsDarkButtonFilledDestructiveHoverSurface = "#980025";
export const semanticsDarkButtonFilledDestructiveFocusText = "#ffffff";
export const semanticsDarkButtonFilledDestructiveFocusIcon = "#ffffff";
export const semanticsDarkButtonFilledDestructiveFocusSurface = "#980025";
export const semanticsDarkButtonFilledDestructiveLoadingText = "#ffffff";
export const semanticsDarkButtonFilledDestructiveLoadingIcon = "#ffffff";
export const semanticsDarkButtonFilledDestructiveLoadingSurface = "#bd002f";
export const semanticsDarkButtonFilledDestructiveDisabledText = "#757575";
export const semanticsDarkButtonFilledDestructiveDisabledIcon = "#757575";
export const semanticsDarkButtonFilledDestructiveDisabledSurface = "#424242";
export const semanticsDarkButtonFilledDestructivePressedText = "#ffffff";
export const semanticsDarkButtonFilledDestructivePressedIcon = "#ffffff";
export const semanticsDarkButtonFilledDestructivePressedSurface = "#4c0013";
export const semanticsDarkButtonFilledSuccessDefaultText = "#ffffff";
export const semanticsDarkButtonFilledSuccessDefaultIcon = "#ffffff";
export const semanticsDarkButtonFilledSuccessDefaultSurface = "#00a85f";
export const semanticsDarkButtonFilledSuccessHoverText = "#ffffff";
export const semanticsDarkButtonFilledSuccessHoverIcon = "#ffffff";
export const semanticsDarkButtonFilledSuccessHoverSurface = "#006539";
export const semanticsDarkButtonFilledSuccessFocusText = "#ffffff";
export const semanticsDarkButtonFilledSuccessFocusIcon = "#ffffff";
export const semanticsDarkButtonFilledSuccessFocusSurface = "#006539";
export const semanticsDarkButtonFilledSuccessLoadingText = "#ffffff";
export const semanticsDarkButtonFilledSuccessLoadingIcon = "#ffffff";
export const semanticsDarkButtonFilledSuccessLoadingSurface = "#00a85f";
export const semanticsDarkButtonFilledSuccessDisabledText = "#757575";
export const semanticsDarkButtonFilledSuccessDisabledIcon = "#9e9e9e";
export const semanticsDarkButtonFilledSuccessDisabledSurface = "#424242";
export const semanticsDarkButtonFilledSuccessPressedText = "#ffffff";
export const semanticsDarkButtonFilledSuccessPressedIcon = "#ffffff";
export const semanticsDarkButtonFilledSuccessPressedSurface = "#004326";
export const semanticsDarkButtonOutlineSecondaryDefaultText = "#141515";
export const semanticsDarkButtonOutlineSecondaryDefaultIcon = "#141515";
export const semanticsDarkButtonOutlineSecondaryDefaultBorder = "#bdbdbd";
export const semanticsDarkButtonOutlineSecondaryHoverText = "#141515";
export const semanticsDarkButtonOutlineSecondaryHoverIcon = "#141515";
export const semanticsDarkButtonOutlineSecondaryHoverBorder = "#bdbdbd";
export const semanticsDarkButtonOutlineSecondaryHoverSurface = "#f5f5f5";
export const semanticsDarkButtonOutlineSecondaryFocusText = "#141515";
export const semanticsDarkButtonOutlineSecondaryFocusIcon = "#141515";
export const semanticsDarkButtonOutlineSecondaryFocusBorder = "#bdbdbd";
export const semanticsDarkButtonOutlineSecondaryFocusSurface = "#f5f5f5";
export const semanticsDarkButtonOutlineSecondaryLoadingText = "#141515";
export const semanticsDarkButtonOutlineSecondaryLoadingIcon = "#141515";
export const semanticsDarkButtonOutlineSecondaryLoadingBorder = "#bdbdbd";
export const semanticsDarkButtonOutlineSecondaryDisabledText = "#757575";
export const semanticsDarkButtonOutlineSecondaryDisabledIcon = "#757575";
export const semanticsDarkButtonOutlineSecondaryDisabledBorder = "#000000";
export const semanticsDarkButtonOutlineSecondaryDisabledSurface = "#424242";
export const semanticsDarkButtonOutlineSecondaryPressedText = "#141515";
export const semanticsDarkButtonOutlineSecondaryPressedIcon = "#141515";
export const semanticsDarkButtonOutlineSecondaryPressedBorder = "#bdbdbd";
export const semanticsDarkButtonOutlineSecondaryPressedSurface = "#9e9e9e";
export const semanticsDarkButtonOutlinePrimaryDefaultText = "#613de4";
export const semanticsDarkButtonOutlinePrimaryDefaultIcon = "#613de4";
export const semanticsDarkButtonOutlinePrimaryDefaultBorder = "#613de4";
export const semanticsDarkButtonOutlinePrimaryHoverText = "#613de4";
export const semanticsDarkButtonOutlinePrimaryHoverIcon = "#613de4";
export const semanticsDarkButtonOutlinePrimaryHoverBorder = "#613de4";
export const semanticsDarkButtonOutlinePrimaryHoverSurface = "#efecfc";
export const semanticsDarkButtonOutlinePrimaryFocusText = "#613de4";
export const semanticsDarkButtonOutlinePrimaryFocusIcon = "#613de4";
export const semanticsDarkButtonOutlinePrimaryFocusBorder = "#613de4";
export const semanticsDarkButtonOutlinePrimaryFocusSurface = "#efecfc";
export const semanticsDarkButtonOutlinePrimaryLoadingText = "#613de4";
export const semanticsDarkButtonOutlinePrimaryLoadingIcon = "#613de4";
export const semanticsDarkButtonOutlinePrimaryLoadingBorder = "#613de4";
export const semanticsDarkButtonOutlinePrimaryDisabledText = "#757575";
export const semanticsDarkButtonOutlinePrimaryDisabledIcon = "#757575";
export const semanticsDarkButtonOutlinePrimaryDisabledBorder = "#000000";
export const semanticsDarkButtonOutlinePrimaryDisabledSurface = "#424242";
export const semanticsDarkButtonOutlinePrimaryPressedText = "#613de4";
export const semanticsDarkButtonOutlinePrimaryPressedIcon = "#613de4";
export const semanticsDarkButtonOutlinePrimaryPressedBorder = "#613de4";
export const semanticsDarkButtonOutlinePrimaryPressedSurface = "#c0b1f4";
export const semanticsDarkButtonOutlineDestructiveDefaultText = "#980025";
export const semanticsDarkButtonOutlineDestructiveDefaultIcon = "#980025";
export const semanticsDarkButtonOutlineDestructiveDefaultBorder = "#bd002f";
export const semanticsDarkButtonOutlineDestructiveHoverText = "#980025";
export const semanticsDarkButtonOutlineDestructiveHoverIcon = "#980025";
export const semanticsDarkButtonOutlineDestructiveHoverBorder = "#bd002f";
export const semanticsDarkButtonOutlineDestructiveHoverSurface = "#f8e5ea";
export const semanticsDarkButtonOutlineDestructiveFocusText = "#980025";
export const semanticsDarkButtonOutlineDestructiveFocusIcon = "#980025";
export const semanticsDarkButtonOutlineDestructiveFocusBorder = "#bd002f";
export const semanticsDarkButtonOutlineDestructiveFocusSurface = "#f8e5ea";
export const semanticsDarkButtonOutlineDestructiveLoadingText = "#980025";
export const semanticsDarkButtonOutlineDestructiveLoadingIcon = "#980025";
export const semanticsDarkButtonOutlineDestructiveLoadingBorder = "#bd002f";
export const semanticsDarkButtonOutlineDestructiveDisabledText = "#757575";
export const semanticsDarkButtonOutlineDestructiveDisabledIcon = "#757575";
export const semanticsDarkButtonOutlineDestructiveDisabledBorder = "#000000";
export const semanticsDarkButtonOutlineDestructiveDisabledSurface = "#424242";
export const semanticsDarkButtonOutlineDestructivePressedText = "#980025";
export const semanticsDarkButtonOutlineDestructivePressedIcon = "#980025";
export const semanticsDarkButtonOutlineDestructivePressedBorder = "#bd002f";
export const semanticsDarkButtonOutlineDestructivePressedSurface = "#e599ac";
export const semanticsDarkButtonOutlineSuccessDefaultText = "#00864c";
export const semanticsDarkButtonOutlineSuccessDefaultIcon = "#00864c";
export const semanticsDarkButtonOutlineSuccessDefaultBorder = "#00a85f";
export const semanticsDarkButtonOutlineSuccessHoverText = "#00864c";
export const semanticsDarkButtonOutlineSuccessHoverIcon = "#00864c";
export const semanticsDarkButtonOutlineSuccessHoverBorder = "#00a85f";
export const semanticsDarkButtonOutlineSuccessHoverSurface = "#e5f6ef";
export const semanticsDarkButtonOutlineSuccessFocusText = "#00864c";
export const semanticsDarkButtonOutlineSuccessFocusIcon = "#00864c";
export const semanticsDarkButtonOutlineSuccessFocusBorder = "#00a85f";
export const semanticsDarkButtonOutlineSuccessFocusSurface = "#e5f6ef";
export const semanticsDarkButtonOutlineSuccessLoadingText = "#00864c";
export const semanticsDarkButtonOutlineSuccessLoadingIcon = "#00864c";
export const semanticsDarkButtonOutlineSuccessLoadingBorder = "#00a85f";
export const semanticsDarkButtonOutlineSuccessDisabledText = "#757575";
export const semanticsDarkButtonOutlineSuccessDisabledIcon = "#757575";
export const semanticsDarkButtonOutlineSuccessDisabledBorder = "#000000";
export const semanticsDarkButtonOutlineSuccessDisabledSurface = "#424242";
export const semanticsDarkButtonOutlineSuccessPressedText = "#00864c";
export const semanticsDarkButtonOutlineSuccessPressedIcon = "#00864c";
export const semanticsDarkButtonOutlineSuccessPressedBorder = "#00a85f";
export const semanticsDarkButtonOutlineSuccessPressedSurface = "#99dcbf";
export const semanticsDarkButtonGhostPrimaryDefaultText = "#613de4";
export const semanticsDarkButtonGhostPrimaryDefaultIcon = "#613de4";
export const semanticsDarkButtonGhostPrimaryHoverText = "#613de4";
export const semanticsDarkButtonGhostPrimaryHoverIcon = "#613de4";
export const semanticsDarkButtonGhostPrimaryHoverSurface = "#efecfc";
export const semanticsDarkButtonGhostPrimaryFocusText = "#613de4";
export const semanticsDarkButtonGhostPrimaryFocusIcon = "#613de4";
export const semanticsDarkButtonGhostPrimaryFocusSurface = "#efecfc";
export const semanticsDarkButtonGhostPrimaryLoadingText = "#613de4";
export const semanticsDarkButtonGhostPrimaryLoadingIcon = "#613de4";
export const semanticsDarkButtonGhostPrimaryDisabledText = "#616161";
export const semanticsDarkButtonGhostPrimaryDisabledIcon = "#616161";
export const semanticsDarkButtonGhostPrimaryPressedText = "#613de4";
export const semanticsDarkButtonGhostPrimaryPressedIcon = "#613de4";
export const semanticsDarkButtonGhostPrimaryPressedSurface = "#c0b1f4";
export const semanticsDarkButtonGhostSecondaryDefaultText = "#141515";
export const semanticsDarkButtonGhostSecondaryDefaultIcon = "#141515";
export const semanticsDarkButtonGhostSecondaryHoverText = "#141515";
export const semanticsDarkButtonGhostSecondaryHoverIcon = "#141515";
export const semanticsDarkButtonGhostSecondaryHoverSurface = "#f5f5f5";
export const semanticsDarkButtonGhostSecondaryFocusText = "#141515";
export const semanticsDarkButtonGhostSecondaryFocusIcon = "#141515";
export const semanticsDarkButtonGhostSecondaryFocusSurface = "#f5f5f5";
export const semanticsDarkButtonGhostSecondaryLoadingText = "#141515";
export const semanticsDarkButtonGhostSecondaryLoadingIcon = "#141515";
export const semanticsDarkButtonGhostSecondaryDisabledText = "#616161";
export const semanticsDarkButtonGhostSecondaryDisabledIcon = "#616161";
export const semanticsDarkButtonGhostSecondaryPressedText = "#141515";
export const semanticsDarkButtonGhostSecondaryPressedIcon = "#141515";
export const semanticsDarkButtonGhostSecondaryPressedSurface = "#bdbdbd";
export const semanticsDarkButtonGhostDestructiveDefaultText = "#980025";
export const semanticsDarkButtonGhostDestructiveDefaultIcon = "#980025";
export const semanticsDarkButtonGhostDestructiveHoverText = "#980025";
export const semanticsDarkButtonGhostDestructiveHoverIcon = "#980025";
export const semanticsDarkButtonGhostDestructiveHoverSurface = "#f8e5ea";
export const semanticsDarkButtonGhostDestructiveFocusText = "#980025";
export const semanticsDarkButtonGhostDestructiveFocusIcon = "#980025";
export const semanticsDarkButtonGhostDestructiveFocusSurface = "#f8e5ea";
export const semanticsDarkButtonGhostDestructiveLoadingText = "#980025";
export const semanticsDarkButtonGhostDestructiveLoadingIcon = "#980025";
export const semanticsDarkButtonGhostDestructiveDisabledText = "#616161";
export const semanticsDarkButtonGhostDestructiveDisabledIcon = "#616161";
export const semanticsDarkButtonGhostDestructivePressedText = "#980025";
export const semanticsDarkButtonGhostDestructivePressedIcon = "#980025";
export const semanticsDarkButtonGhostDestructivePressedSurface = "#e599ac";
export const semanticsDarkButtonGhostSuccessDefaultText = "#00864c";
export const semanticsDarkButtonGhostSuccessDefaultIcon = "#00864c";
export const semanticsDarkButtonGhostSuccessHoverText = "#00864c";
export const semanticsDarkButtonGhostSuccessHoverIcon = "#00864c";
export const semanticsDarkButtonGhostSuccessHoverSurface = "#e5f6ef";
export const semanticsDarkButtonGhostSuccessFocusText = "#00864c";
export const semanticsDarkButtonGhostSuccessFocusIcon = "#00864c";
export const semanticsDarkButtonGhostSuccessFocusSurface = "#e5f6ef";
export const semanticsDarkButtonGhostSuccessLoadingText = "#00864c";
export const semanticsDarkButtonGhostSuccessLoadingIcon = "#00864c";
export const semanticsDarkButtonGhostSuccessDisabledText = "#616161";
export const semanticsDarkButtonGhostSuccessDisabledIcon = "#616161";
export const semanticsDarkButtonGhostSuccessPressedText = "#00864c";
export const semanticsDarkButtonGhostSuccessPressedIcon = "#00864c";
export const semanticsDarkButtonGhostSuccessPressedSurface = "#99dcbf";
export const semanticsDarkText = "#ffffff";
export const semanticsDarkIcon = "#ffffff";
export const semanticsDarkSurface = "#27185b";
export const semanticsDarkInputDefaultDefaultBorder = "#bdbdbd";
export const semanticsDarkInputDefaultDefaultLeftIcon = "#141515";
export const semanticsDarkInputDefaultDefaultRightIcon = "#9e9e9e";
export const semanticsDarkInputDefaultDefaultLabel = "#141515";
export const semanticsDarkInputDefaultDefaultPlaceholder = "#757575";
export const semanticsDarkInputDefaultDefaultDescription = "#757575";
export const semanticsDarkInputDefaultDefaultLink = "#9e9e9e";
export const semanticsDarkInputDefaultDefaultSurface = "#ffffff";
export const semanticsDarkInputDefaultFocusLabel = "#141515";
export const semanticsDarkInputDefaultFocusLink = "#9e9e9e";
export const semanticsDarkInputDefaultFocusPlaceholder = "#757575";
export const semanticsDarkInputDefaultFocusDescription = "#757575";
export const semanticsDarkInputDefaultFocusLeftIcon = "#141515";
export const semanticsDarkInputDefaultFocusRightIcon = "#9e9e9e";
export const semanticsDarkInputDefaultFocusBorder = "#bdbdbd";
export const semanticsDarkInputDefaultFocusSurface = "#ffffff";
export const semanticsDarkInputDefaultFilledLabel = "#141515";
export const semanticsDarkInputDefaultFilledLink = "#9e9e9e";
export const semanticsDarkInputDefaultFilledPlaceholder = "#141515";
export const semanticsDarkInputDefaultFilledDescription = "#757575";
export const semanticsDarkInputDefaultFilledLeftIcon = "#141515";
export const semanticsDarkInputDefaultFilledRightIcon = "#9e9e9e";
export const semanticsDarkInputDefaultFilledBorder = "#bdbdbd";
export const semanticsDarkInputDefaultFilledSurface = "#ffffff";
export const semanticsDarkInputDefaultDisabledLabel = "#141515";
export const semanticsDarkInputDefaultDisabledLink = "#9e9e9e";
export const semanticsDarkInputDefaultDisabledPlaceholder = "#757575";
export const semanticsDarkInputDefaultDisabledDescription = "#757575";
export const semanticsDarkInputDefaultDisabledLeftIcon = "#757575";
export const semanticsDarkInputDefaultDisabledRightIcon = "#9e9e9e";
export const semanticsDarkInputDefaultDisabledBorder = "#bdbdbd";
export const semanticsDarkInputDefaultDisabledSurface = "#e0e0e0";
export const semanticsDarkInputDefaultErrorLabel = "#141515";
export const semanticsDarkInputDefaultErrorLink = "#9e9e9e";
export const semanticsDarkInputDefaultErrorPlaceholder = "#141515";
export const semanticsDarkInputDefaultErrorDescription = "#757575";
export const semanticsDarkInputDefaultErrorLeftIcon = "#141515";
export const semanticsDarkInputDefaultErrorRightIcon = "#9e9e9e";
export const semanticsDarkInputDefaultErrorBorder = "#bd002f";
export const semanticsDarkInputDefaultErrorSurface = "#ffffff";
export const semanticsDarkInputDefaultErrorFocusLabel = "#141515";
export const semanticsDarkInputDefaultErrorFocusLink = "#9e9e9e";
export const semanticsDarkInputDefaultErrorFocusPlaceholder = "#141515";
export const semanticsDarkInputDefaultErrorFocusDescription = "#757575";
export const semanticsDarkInputDefaultErrorFocusLeftIcon = "#141515";
export const semanticsDarkInputDefaultErrorFocusRightIcon = "#9e9e9e";
export const semanticsDarkInputDefaultErrorFocusBorder = "#bd002f";
export const semanticsDarkInputDefaultErrorFocusSurface = "#ffffff";
export const semanticsDarkInputFileDefaultLabel = "#141515";
export const semanticsDarkInputFileDefaultLabelText = "#141515";
export const semanticsDarkInputFileDefaultDescription = "#757575";
export const semanticsDarkInputFileDefaultBorder = "#bdbdbd";
export const semanticsDarkInputFileDefaultSurface = "#ffffff";
export const semanticsDarkInputFileDefaultButtonText = "#757575";
export const semanticsDarkInputFileFocusLabel = "#141515";
export const semanticsDarkInputFileFocusLabelText = "#141515";
export const semanticsDarkInputFileFocusButtonText = "#757575";
export const semanticsDarkInputFileFocusDescription = "#757575";
export const semanticsDarkInputFileFocusBorder = "#bdbdbd";
export const semanticsDarkInputFileFocusSurface = "#ffffff";
export const semanticsDarkInputFileFilledLabel = "#141515";
export const semanticsDarkInputFileFilledLabelText = "#141515";
export const semanticsDarkInputFileFilledButtonText = "#141515";
export const semanticsDarkInputFileFilledDescription = "#757575";
export const semanticsDarkInputFileFilledBorder = "#bdbdbd";
export const semanticsDarkInputFileFilledSurface = "#ffffff";
export const semanticsDarkInputFileDisabledLabel = "#141515";
export const semanticsDarkInputFileDisabledLabelText = "#757575";
export const semanticsDarkInputFileDisabledButtonText = "#757575";
export const semanticsDarkInputFileDisabledDescription = "#757575";
export const semanticsDarkInputFileDisabledBorder = "#bdbdbd";
export const semanticsDarkInputFileDisabledSurface = "#e0e0e0";
export const semanticsDarkInputFileErrorLabel = "#141515";
export const semanticsDarkInputFileErrorLabelText = "#141515";
export const semanticsDarkInputFileErrorButtonText = "#141515";
export const semanticsDarkInputFileErrorDescription = "#980025";
export const semanticsDarkInputFileErrorBorder = "#bd002f";
export const semanticsDarkInputFileErrorSurface = "#ffffff";
export const semanticsDarkInputFileErrorFocusLabel = "#141515";
export const semanticsDarkInputFileErrorFocusLabelText = "#141515";
export const semanticsDarkInputFileErrorFocusButtonText = "#141515";
export const semanticsDarkInputFileErrorFocusDescription = "#980025";
export const semanticsDarkInputFileErrorFocusBorder = "#bd002f";
export const semanticsDarkInputFileErrorFocusSurface = "#ffffff";
export const semanticsDarkSelectDefaultLabel = "#141515";
export const semanticsDarkSelectDefaultPlaceholder = "#757575";
export const semanticsDarkSelectDefaultDescription = "#757575";
export const semanticsDarkSelectDefaultLeftIcon = "#141515";
export const semanticsDarkSelectDefaultRightIcon = "#9e9e9e";
export const semanticsDarkSelectDefaultBorder = "#bdbdbd";
export const semanticsDarkSelectDefaultSurface = "#ffffff";
export const semanticsDarkSelectFocusLabel = "#141515";
export const semanticsDarkSelectFocusPlaceholder = "#757575";
export const semanticsDarkSelectFocusDescription = "#757575";
export const semanticsDarkSelectFocusLeftIcon = "#141515";
export const semanticsDarkSelectFocusRightIcon = "#9e9e9e";
export const semanticsDarkSelectFocusBorder = "#bdbdbd";
export const semanticsDarkSelectFocusSurface = "#f5f5f5";
export const semanticsDarkSelectFilledLabel = "#141515";
export const semanticsDarkSelectFilledPlaceholder = "#141515";
export const semanticsDarkSelectFilledDescription = "#757575";
export const semanticsDarkSelectFilledLeftIcon = "#141515";
export const semanticsDarkSelectFilledRightIcon = "#9e9e9e";
export const semanticsDarkSelectFilledBorder = "#bdbdbd";
export const semanticsDarkSelectFilledSurface = "#ffffff";
export const semanticsDarkSelectFilledFocusLabel = "#141515";
export const semanticsDarkSelectFilledFocusPlaceholder = "#141515";
export const semanticsDarkSelectFilledFocusDescription = "#757575";
export const semanticsDarkSelectFilledFocusLeftIcon = "#141515";
export const semanticsDarkSelectFilledFocusRightIcon = "#9e9e9e";
export const semanticsDarkSelectFilledFocusBorder = "#bdbdbd";
export const semanticsDarkSelectFilledFocusSurface = "#ffffff";
export const semanticsDarkSelectDisabledLabel = "#141515";
export const semanticsDarkSelectDisabledPlaceholder = "#757575";
export const semanticsDarkSelectDisabledDescription = "#757575";
export const semanticsDarkSelectDisabledLeftIcon = "#141515";
export const semanticsDarkSelectDisabledRightIcon = "#9e9e9e";
export const semanticsDarkSelectDisabledBorder = "#bdbdbd";
export const semanticsDarkSelectDisabledSurface = "#e0e0e0";
export const semanticsDarkSelectMenuLabelDefaultText = "#9e9e9e";
export const semanticsDarkSelectMenuItemDefaultText = "#141515";
export const semanticsDarkSelectMenuItemDefaultIcon = "#141515";
export const semanticsDarkSelectMenuItemDefaultBorder = "#bdbdbd";
export const semanticsDarkSelectMenuItemDefaultAccent = "#f5f5f5";
export const semanticsDarkSelectMenuContainerDefaultSurface = "#ffffff";
export const semanticsDarkSelectMenuContainerDefaultBorder = "#e0e0e0";
export const semanticsDarkAvatarFallbackDefaultText = "#4e31b6";
export const semanticsDarkAvatarFallbackDefaultSurface = "#efecfc";
export const semanticsDarkAvatarGroupDefaultBorder = "#141515";
export const semanticsDarkUserChipSelectedDefaultText = "#141515";
export const semanticsDarkUserChipSelectedDefaultBorder = "#613de4";
export const semanticsDarkUserChipSelectedDefaultSurface = "#f7f5fe";
export const semanticsDarkUserChipSelectedHoverText = "#141515";
export const semanticsDarkUserChipSelectedHoverBorder = "#613de4";
export const semanticsDarkUserChipSelectedHoverSurface = "#efecfc";
export const semanticsDarkUserChipUnselectedDefaultText = "#141515";
export const semanticsDarkUserChipUnselectedDefaultBorder = "#e0e0e0";
export const semanticsDarkUserChipUnselectedDefaultSurface = "#ffffff";
export const semanticsDarkUserChipUnselectedHoverText = "#141515";
export const semanticsDarkUserChipUnselectedHoverBorder = "#e0e0e0";
export const semanticsDarkUserChipUnselectedHoverSurface = "#fafafa";
export const semanticsDarkUserChipDisabledDefaultText = "#757575";
export const semanticsDarkUserChipDisabledDefaultSurface = "#e0e0e0";
export const semanticsDarkImageChipSelectedDefaultBorder = "#613de4";
export const semanticsDarkImageChipSelectedDefaultSurface = "#f7f5fe";
export const semanticsDarkImageChipSelectedHoverBorder = "#613de4";
export const semanticsDarkImageChipSelectedHoverSurface = "#efecfc";
export const semanticsDarkImageChipUnselectedDefaultBorder = "#e0e0e0";
export const semanticsDarkImageChipUnselectedDefaultSurface = "#ffffff";
export const semanticsDarkImageChipUnselectedHoverBorder = "#e0e0e0";
export const semanticsDarkImageChipUnselectedHoverSurface = "#fafafa";
export const semanticsDarkImageChipDisabledDefaultSurface = "#e0e0e0";
export const semanticsDarkCheckboxActiveDefaultLabel = "#141515";
export const semanticsDarkCheckboxActiveDefaultDescription = "#757575";
export const semanticsDarkCheckboxActiveDefaultBorder = "#613de4";
export const semanticsDarkCheckboxActiveDefaultSurface = "#613de4";
export const semanticsDarkCheckboxActiveDefaultIcon = "#ffffff";
export const semanticsDarkCheckboxActiveFocusLabel = "#141515";
export const semanticsDarkCheckboxActiveFocusDescription = "#757575";
export const semanticsDarkCheckboxActiveFocusIcon = "#ffffff";
export const semanticsDarkCheckboxActiveFocusBorder = "#613de4";
export const semanticsDarkCheckboxActiveFocusSurface = "#613de4";
export const semanticsDarkCheckboxActiveDisabledLabel = "#757575";
export const semanticsDarkCheckboxActiveDisabledDescription = "#757575";
export const semanticsDarkCheckboxActiveDisabledIcon = "#ffffff";
export const semanticsDarkCheckboxActiveDisabledBorder = "#757575";
export const semanticsDarkCheckboxActiveDisabledSurface = "#757575";
export const semanticsDarkCheckboxActivePressedLabel = "#130c2e";
export const semanticsDarkCheckboxActivePressedDescription = "#757575";
export const semanticsDarkCheckboxActivePressedIcon = "#ffffff";
export const semanticsDarkCheckboxActivePressedBorder = "#130c2e";
export const semanticsDarkCheckboxActivePressedSurface = "#130c2e";
export const semanticsDarkCheckboxInactiveDefaultLabel = "#141515";
export const semanticsDarkCheckboxInactiveDefaultDescription = "#757575";
export const semanticsDarkCheckboxInactiveDefaultBorder = "#e0e0e0";
export const semanticsDarkCheckboxInactiveDefaultSurface = "#ffffff";
export const semanticsDarkCheckboxInactiveFocusLabel = "#141515";
export const semanticsDarkCheckboxInactiveFocusDescription = "#757575";
export const semanticsDarkCheckboxInactiveFocusBorder = "#e0e0e0";
export const semanticsDarkCheckboxInactiveFocusSurface = "#ffffff";
export const semanticsDarkCheckboxInactiveDisabledLabel = "#757575";
export const semanticsDarkCheckboxInactiveDisabledDescription = "#757575";
export const semanticsDarkCheckboxInactiveDisabledBorder = "#e0e0e0";
export const semanticsDarkCheckboxInactiveDisabledSurface = "#ffffff";
export const semanticsDarkCheckboxInactivePressedLabel = "#130c2e";
export const semanticsDarkCheckboxInactivePressedDescription = "#757575";
export const semanticsDarkCheckboxInactivePressedBorder = "#e0e0e0";
export const semanticsDarkCheckboxInactivePressedSurface = "#ffffff";
export const semanticsDarkRadioInactiveDefaultLabel = "#141515";
export const semanticsDarkRadioInactiveDefaultDescription = "#757575";
export const semanticsDarkRadioInactiveDefaultBorder = "#e0e0e0";
export const semanticsDarkRadioInactiveDefaultSurface = "#ffffff";
export const semanticsDarkRadioInactiveFocusLabel = "#141515";
export const semanticsDarkRadioInactiveFocusDescription = "#757575";
export const semanticsDarkRadioInactiveFocusBorder = "#9e9e9e";
export const semanticsDarkRadioInactiveFocusSurface = "#ffffff";
export const semanticsDarkRadioActiveDefaultLabel = "#141515";
export const semanticsDarkRadioActiveDefaultDescription = "#757575";
export const semanticsDarkRadioActiveDefaultBorder = "#e0e0e0";
export const semanticsDarkRadioActiveDefaultSurface = "#ffffff";
export const semanticsDarkRadioActiveDefaultIcon = "#613de4";
export const semanticsDarkRadioActiveFocusLabel = "#141515";
export const semanticsDarkRadioActiveFocusDescription = "#757575";
export const semanticsDarkRadioActiveFocusIcon = "#613de4";
export const semanticsDarkRadioActiveFocusBorder = "#9e9e9e";
export const semanticsDarkRadioActiveFocusSurface = "#ffffff";
